import { FormatMessage } from 'types/common'

export enum INPUT_TYPES {
  BOOLEAN = 'boolean',
  SELECT = 'select',
}

export interface ImagesInputOptionLabel {
  title: string
  description: string
  url: string
}

export interface Option {
  label: string | ImagesInputOptionLabel
  value: string
}

export interface Input {
  id?: string
  label: string
  task: string
  title?: string
  type: INPUT_TYPES
  value: number
  options?: Option[]
}

export interface SelectedInput {
  input: number
  values: (string | null | boolean)[]
}

export interface ValidationErrors {
  [key: string]: string
}

export type TriggerInputsProps = {
  inputs: Input[]
  selectedInputs: SelectedInput[]
  formatMessage: FormatMessage
  onChangeFormValue: (value: SelectedInput[], key: string) => void
  validationErrors: ValidationErrors
  setValidationErrors: (errors: ValidationErrors) => void
}
